import React from 'react';
import { get, size, groupBy, map } from 'lodash/fp';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { ReservationOrderType } from '../../../../interfaces/reservation';

const styles = StyleSheet.create({
  orderPicklist: {
    borderRadius: 5,
    border: '1px solid #ddd',
    width: '98%',
    margin: '0 8px 10px 0'
  },
  picklistName: {
    padding: 6,
    fontSize: 9,
    color: '#000',
    textAlign: 'center',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    textTransform: 'uppercase',
    backgroundColor: '#86cce7',
    fontWeight: 'bold'
  },
  categorySection: {
    width: '100%',
    borderBottom: 'none'
  },
  categoryName: {
    padding: 6,
    fontSize: 10,
    color: '#000',
    textAlign: 'center',
    backgroundColor: '#efefef'
  },
  itemsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  orderItem: {
    fontSize: 8,
    width: '25%',
    flexGrow: 0,
    textTransform: 'uppercase',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  itemName: {
    padding: 5,
    width: '75%',
    color: '#000',
    display: 'inline',
    flexGrow: 4
  },
  itemQty: {
    width: '25%',
    padding: '5px 0',
    display: 'inline',
    textAlign: 'center',
    flexGrow: 1,
    fontSize: 11
  },
  itemNote: {
    padding: '15px 5px',
    fontSize: 10,
    color: '#333',
    borderTop: '1px solid #ddd',
    fontStyle: 'italic'
  }
});

const ReservationOrder = ({ data }) => {
  const { items, picklistSnapshot, notes } = data;
  const itemsByCategory = groupBy('picklistCategoryId', items);
  return (
    <View style={styles.orderPicklist}>
      <Text style={styles.picklistName}>{picklistSnapshot.name}</Text>
      <View style={styles.itemsSection}>
        {map(categoryItems => {
          const itemsLength = size(categoryItems);
          const withBorderLength = Math.floor(itemsLength / 4) * 4;
          const category = get('0.categorySnapshot.name', categoryItems);
          return (
            <View key={`category-${category}`} style={styles.categorySection}>
              <Text style={styles.categoryName}>{category}</Text>
              <View style={styles.itemsSection}>
                {categoryItems.map(({ id, quantity, itemSnapshot }, i) => (
                  <View
                    key={`orderItem-${id}`}
                    style={{
                      ...styles.orderItem,
                      borderBottom:
                        itemsLength >= 4 && i < withBorderLength
                          ? '1px solid #ddd'
                          : 'none',
                      borderRight: (i + 1) % 4 === 0 ? 'none' : '1px solid #ddd'
                    }}
                  >
                    <Text style={styles.itemName} break>
                      {itemSnapshot.name}
                    </Text>
                    <Text style={styles.itemQty}>{quantity}</Text>
                  </View>
                ))}
              </View>
            </View>
          );
        }, itemsByCategory)}
      </View>
      {!!notes && (
        <Text style={styles.itemNote} break>{`Notes: ${notes}`}</Text>
      )}
    </View>
  );
};

ReservationOrder.propTypes = {
  data: ReservationOrderType.isRequired
};

export default ReservationOrder;
